var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("loading-anim", {
        attrs: { active: _vm.$store.state.loading, fullScreen: "" }
      }),
      _vm._v(" "),
      _c(
        "b-navbar",
        { staticClass: "navbar", attrs: { toggleable: "lg" } },
        [
          _c(
            "router-link",
            { attrs: { to: "/" } },
            [
              _c("b-navbar-brand", [
                _c("img", {
                  staticClass: "navbar-brand-img",
                  style: _vm.getLogoStyles,
                  attrs: { src: _vm.getLogo }
                })
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-navbar-nav",
            { staticClass: "ml-auto" },
            [
              _c(
                "b-nav-item",
                [
                  _c(
                    "base-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.backVisible,
                          expression: "backVisible"
                        }
                      ],
                      staticClass: "btn-layout",
                      attrs: { blue: "" },
                      on: { click: _vm.back }
                    },
                    [
                      _c("base-icon", {
                        staticClass: "mr-2",
                        attrs: {
                          src:
                            "/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg",
                          color: "white",
                          svgClasses: "reverse"
                        }
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.$t("back")))])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "ctm-container" },
        [
          _c(
            "b-row",
            { staticClass: "pt-3" },
            [
              _c(
                "b-col",
                {
                  class: _vm.colClasses,
                  attrs: { cols: "12", sm: "8", md: "6" }
                },
                [
                  _vm.$route.meta.title && !_vm.$route.meta.title.hide
                    ? _c("h3", { class: _vm.styleClasses }, [
                        _vm._v(_vm._s(_vm.getMetaTitle))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("router-view", { staticClass: "mt-4" })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5b7b8999", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b7b8999","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/PublicReducedLayout.vue
// module id = 2139
// module chunks = 120